import React, { Component } from 'react';

class IconReopen extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0"
                y="0"
                enableBackground="new 0 0 592.8 592.8"
                version="1.1"
                viewBox="0 0 592.8 592.8"
                xmlSpace="preserve"
                fill="#1D53A5"
                width="17"
                height="17"
            >
                <path
                    d="M589.2 356.2L484.4 554.5c-5.1 9.9-19.7 20.3-30.9 20.3l-420.1.1c-8.9 0-17.4-3.5-23.7-9.8-6.2-6.3-9.7-14.8-9.7-23.7l.1-326.2c0-18.4 15-33.4 33.4-33.4h30.7v28.5H43.6c-4 0-7.9 1.6-10.7 4.4-2.8 2.8-4.4 6.7-4.4 10.7v305.8c0 8.4 6.8 15.2 15.2 15.2h21L164 345.5c5.6-11.2 16.2-20.3 27.4-20.3h243.1l.1-80.8c15.9 1.5 28.4 14.6 28.4 30.9v49.9h111.5c13.2.2 24.3 13.2 14.7 31zM83.6 445.3c-.9-100 0-399.9 0-399.9C83.6 30.3 95.9 18 111 18h219.6c3.5 0 6.9 1.5 9.3 4.1l71 77.1c2.1 2.3 3.3 5.4 3.3 8.5v199.8h-23V124.9c0-3.2-2.6-5.7-5.7-5.7h-54.3c-6.4 0-11.5-5.2-11.5-11.5v-61c0-3.2-2.6-5.7-5.7-5.7H111c-2.4 0-4.4 2-4.4 4.4v374.7L89 455.8s-5.4-.4-5.4-10.5zm259-349.1h34.2L342.6 59v37.2zm12.5 46.5H142.8c-7.8 0-14.2 6.4-14.2 14.2 0 7.8 6.4 14.2 14.2 14.2h212.3c7.8 0 14.2-6.4 14.2-14.2-.1-7.9-6.4-14.2-14.2-14.2zm14.1 96.7c0-7.8-6.4-14.2-14.2-14.2H142.8c-7.8 0-14.2 6.4-14.2 14.2 0 7.8 6.4 14.2 14.2 14.2h212.3c7.8-.1 14.1-6.4 14.1-14.2zm-240.6 83.1c0 7.8 6.4 14.2 14.2 14.2h5.1c9-25 31.2-28.3 31.2-28.3h-36.3c-7.8-.1-14.2 6.3-14.2 14.1zM878.2 225.6v-35.5-34.3c0-3.6-2.4-5.9-5.9-5.9h-39c-5.6-.2-10.7 2.4-10.7 9.5v4.7h-54.5c-3.6 0-5.9 2.4-5.9 5.9v85.3c0 3.6 2.4 5.9 5.9 5.9 8.3-1.2 95.9-13 103-14.2 4.7 0 7.1-3.6 7.1-7.1v-14.3z"
                    className="st0"
                ></path>
            </svg>
        );
    }
}

export default IconReopen;